import React from "react";
import { Link } from "react-router-dom";
import { MapPin, Heart, Sparkles } from "lucide-react";

const ABOUT_IMG = "https://customer-assets.emergentagent.com/job_hometown-era/artifacts/j1pansnl_A8FC09D6-4628-46AE-9796-074749941CB3.png";

const SPECIALTIES = ["Pokémon Cards", "Sports Cards", "Sealed Products", "Singles", "Graded Cards"];

export default function About() {
  return (
    <div data-testid="about-page">
      <section className="bg-[#262626] text-[#F9F6F0]">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid md:grid-cols-2 gap-12 items-center">
          <div>
            <span className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.2em] text-[#D32F2F]">
              <MapPin className="w-4 h-4" /> Galt, California
            </span>
            <h1 className="mt-4 text-4xl sm:text-5xl font-black tracking-tighter">A family-owned & family-centered card shop.</h1>
            <p className="mt-6 text-lg text-[#F9F6F0]/80 leading-relaxed">
              Hometown Era Cards brings people together through a shared love of collecting. What started as a
              lifelong passion has grown into a dream come true for our family.
            </p>
          </div>
          <img src={ABOUT_IMG} alt="Our family collecting together" className="rounded-lg w-full h-80 md:h-96 object-cover object-top" />
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-12 py-20 md:py-28">
        <div className="space-y-7 text-lg text-[#262626]/80 leading-relaxed">
          <p>
            Growing up around sports cards, trading cards, and collecting, the hobby has always been a big part of
            our lives. As a dad of two boys who love collecting just as much as I do — and with a baby girl on the
            way — we wanted to create something special that could be shared across generations.
          </p>
          <p>
            Building Hometown Era Cards is more than starting a business; it's about creating memories, passing down
            traditions, and sharing the excitement of the hobby with our children.
          </p>
          <p>
            One of my lifelong dreams has been to build something meaningful that I could hand down to my kids
            someday. Spending time at shows, talking cards, meeting collectors, and enjoying the hobby alongside my
            children makes every day feel less like work and more like another fun day spent together as a family.
          </p>
          <div className="border-l-4 border-[#D32F2F] pl-6 py-2">
            <p className="font-display font-bold text-xl text-[#262626] not-italic">
              Our mission: provide collectors with a trustworthy place to buy, sell, trade, and enjoy the hobby —
              while fostering a welcoming community for collectors of all ages.
            </p>
          </div>
        </div>

        <div className="mt-12">
          <h2 className="font-display font-bold text-2xl text-[#262626] flex items-center gap-2">
            <Sparkles className="w-5 h-5 text-[#D32F2F]" /> What We Specialize In
          </h2>
          <div className="flex flex-wrap gap-3 mt-5">
            {SPECIALTIES.map((s) => (
              <span key={s} className="bg-white border border-[#262626]/15 rounded-full px-5 py-2.5 text-sm font-semibold text-[#262626]">
                {s}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white border-t border-[#262626]/10">
        <div className="max-w-7xl mx-auto px-6 md:px-12 py-16 text-center">
          <Heart className="w-10 h-10 text-[#D32F2F] mx-auto" />
          <h2 className="mt-5 text-3xl font-bold tracking-tight text-[#262626]">Come collect with our family.</h2>
          <p className="mt-3 text-[#262626]/70 max-w-xl mx-auto">Whether you're starting your first binder or chasing a grail card, there's a place for you here.</p>
          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link to="/products" className="bg-[#D32F2F] text-white font-bold px-7 py-3.5 rounded-md hover:bg-[#B71C1C] transition-colors">Shop Now</Link>
            <Link to="/contact" className="border-2 border-[#262626] text-[#262626] font-bold px-7 py-3.5 rounded-md hover:bg-[#262626] hover:text-[#F9F6F0] transition-colors">Get in Touch</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
